// @flow
import React from "react";
import "@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css";
import "@ta-interaktiv/semantic-ui/semantic/dist/components/site.css";
import "@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css";
import "@ta-interaktiv/semantic-ui/semantic/dist/components/container.css";
import "@ta-interaktiv/semantic-ui/semantic/dist/components/header.css";
import "@ta-interaktiv/semantic-ui/semantic/dist/components/image.css";
import "@ta-interaktiv/semantic-ui/semantic/dist/components/list.css";
import "@ta-interaktiv/semantic-ui/semantic/dist/components/card.css";
import "@ta-interaktiv/semantic-ui/semantic/dist/components/dropdown.css";
import "react-dropdown/style.css";
import Scrollchor from "react-scrollchor";
import { hot } from "react-hot-loader/root";
import "./styles.scss";
import Masthead from "@ta-interaktiv/react-masthead";
import { Footer } from "@ta-interaktiv/react-footer";
import ThemeSwitch from "@ta-interaktiv/react-theme-switch";
import { Route, withRouter, Redirect } from "react-router-dom";
import Question from "../question";
import { parseHostname } from "@ta-interaktiv/parse-hostname";

const ARTICLE_ID = "20611024";

function AppComponent() {
  return (
    <div className="index">
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />

      {/* <div className="cover" style={{backgroundImage: 'url(' + require('./cover.jpg') + ')'}}> */}
      <header className="ui vertical fitted segment" id="start">
        <div className="ui container">
          <h1 className="ui header" style={{ marginBottom: 0 }}>
            Quel élu vous représente le mieux?
          </h1>
          <h2 className="ui header" style={{ marginTop: 0 }}>
            <div className="small sub header">
              En quatre ans, ils ont dit oui, non, ou se sont abstenus des
              centaines de fois. Alors que les Suisses doivent élire leurs
              représentants à Berne le 20 octobre, nous vous proposons de
              rejouer certains votes marquants de la législature.
            </div>
          </h2>
          <p className="ta author">
            <strong>Florent Quiquerez, Mathieu Rudaz</strong>
          </p>
        </div>
      </header>
      <div className="ui container">
        <img className="cover-image" src={require("./cover.jpg")} />
      </div>

      <div className="ui vertical segment">
        <div className="ui text container">
          <p>
            Derrière les portes du Palais fédéral, c’est une certaine vision de
            la Suisse qui est débattue quatre fois par année durant les trois
            semaines de session. Deux cents conseillers nationaux et 46
            conseillers aux États font et défont des lois, suivant une logique
            partisane ou des convictions personnelles.{" "}
            {/* Ces quatre
            dernières années, de grands projets ont été concocté durant des
            mois, permettant aux élus de tisser pas à pas le compromis
            helvétique. D’autres proposition ont été réglées plus vite, le temps
            d’un débat, parfois très émotionnel. */}
          </p>

          <p>
            Au travers de ce test, nous vous proposons de vous mettre à la place
            d’un conseiller national et de trancher vous aussi en faveur ou
            contre des propositions. Les questions ont été choisies en fonction
            des grands thèmes qui ont animé la dernière législature, mais aussi
            de façon à percevoir les différences parfois fines qui existent
            entre les partis. De quel parlementaire auriez-vous été le plus
            proche, et inversement? À vos marques, prêts, votez.{" "}
            <Scrollchor to="#methodology" className="recherche-link">
              <i
                style={{ display: "inline" }}
                className="small double angle down icon"
              />
              &nbsp;Apprenez-en plus sur la méthode ici.
            </Scrollchor>
          </p>
        </div>
      </div>

      <div className="ui grey vertical segment">
        <Route exact path="/" render={() => <Redirect to="/question/1" />} />
        <Route
          render={props => <Question {...props} />}
          path={"/question/:questionId"}
        />
      </div>

      <div className="ui vertical segment" id="methodology">
        <div className="ui text container">
          <h4 className="ui header">Méthode</h4>
          <p>
            Tous les détails des votes peuvent être retrouvés sur le site de
            l'Assemblée fédérale (
            <a href="https://www.parlament.ch/fr/ratsbetrieb/abstimmungen/qui-a-vot-comment-au-conseil-national">
              <i className="external alternate icon" />
              &nbsp;Qui a voté comment au Conseil national
            </a>
            ). Nous avons compilé les données de l'ensemble des votes de la 50e
            législature du Conseil national (
            <a href="https://www.parlament.ch/fr/ratsbetrieb/abstimmungen/abstimmung-nr-xls">
              <i className="external alternate icon" />
              &nbsp;Banque de données sur le détail des votes
            </a>
            ), du 30 novembre 2015 au premier décembre 2019.
          </p>
          <p>
            Les votes des députés qui ont quitté le Conseil national en cours de
            législature ont été ajoutés aux votes de leur remplaçant. Le nom des
            parlementaires qui ont quitté leur fonction durant la legislature et
            avant d'avoir voté à tous les objets que nous avons choisis
            n'apparait pas dans les résultats. C'est le nom de leur remplaçant
            qui est affiché. Si un parlementaire a quitté ses fonctions en cours
            de legislature mais après avoir voté à tous les objets que nous
            avons choisis, c'est lui et non son remplaçant que nous montrons.
          </p>
          <p>
            Un parlementaire absent ou excusé lors d'un vote est compté dans le
            calcul de la moyenne des votes similaires. Par exemple, un
            parlementaire absent lors du premier vote, puis qui vote comme vous
            au prochain, obtiendra un score de 50%. C'est la raison pour
            laquelle Christa Markwalder, présidente du Conseil national lors du
            vote des 5 premiers objets que nous avons choisis, a peu de chance
            de se trouver parmi les parlementaires qui ont voté comme vous
            puisque le président ne vote pas.
          </p>
          <p>
            Daniel Frei a rejoint les Vert'libéraux en cours de législature. Il
            a néanmoins voté tous les objets choisis pour ce questionnaire en
            tant que socialiste. Nous l'avons donc laissé dans le groupe
            parlementaire socialiste.
          </p>
          <p>
            Si aucun représentant de votre canton n'a été trouvé parmi les
            parlementaires les plus proches ou les plus éloignés, nous vous
            montrons un parlementaire choisi aléatoirement.
          </p>
        </div>
      </div>

      <div className="ui text center aligned container">
        <div
          className="ui raised segment"
          style={{ fontFamily: "TamediaChart, sans-serif", marginTop: "2em" }}
        >
          <a
            href={
              "https://www." +
              parseHostname().publicationDomain +
              "/suisse/federales_2019/"
            }
          >
            <i className="external alternate icon" />
            Notre dossier Élections fédérales
          </a>
        </div>
      </div>

      <Footer
        hidePortfolioTeaser
        mailTo="mathieu.rudaz@tamedia.ch"
        locale="fr"
        articleId={ARTICLE_ID}
        credits={[
          ["Textes et recherche", "Florent Quiquerez, Mathieu Rudaz"],
          ["Conception", "Mathieu Rudaz"],
          ["Idée originale", "Fanny Giroud"]
        ]}
      />
    </div>
  );
}

export default hot(withRouter(AppComponent));
